import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

interface Workflow {
  id: string;
  [key: string]: any;
}

interface WorkflowState {
  workflows: Workflow[] | null; // Storage for initial data
}

const initialState: WorkflowState = {
  workflows: null,
};

const workflowSlice = createSlice({
  name: 'workflow',
  initialState,
  reducers: {
    setWorkflows: (state, action: PayloadAction<Workflow[]>) => {
      state.workflows = action.payload;
    },
    updateWorkflow: (
      state,
      action: PayloadAction<{ id: string; updatedData: Partial<Workflow> }>,
    ) => {
      if (state.workflows) {
        state.workflows = state.workflows.map((workflow) =>
          workflow.id === action.payload.id
            ? { ...workflow, ...action.payload.updatedData }
            : workflow,
        );
      }
    },
    resetInitialData: (state) => {
      state.workflows = null;
    },
  },
});

export const selectWorkflows = (state: RootState): Workflow[] | null => state.workflow.workflows;

export const selectWorkflowById = (state: RootState, id: string): Workflow | undefined => {
  const list = state.workflow.workflows;
  if (!Array.isArray(list)) return undefined;
  return list.find((workflow: any) => workflow.featureId === id);
};

export const { setWorkflows, resetInitialData, updateWorkflow } = workflowSlice.actions;
export default workflowSlice.reducer;
